export default "__VITE_ASSET__KRCclbZs__"